import { Component } from '@angular/core';

@Component({
  selector: 'app-syllabus-add-button',
  template: '<ng-content></ng-content>'
})
export class SyllabusAddButtonComponent{

  constructor() { }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/syllabus-add-button/syllabus-add-button.component.ts